<template>
  <div class="container">
    <div class="row success justify-content-center m-0">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div class="text-center">
              <img src="/assets/images/icons/logo-true.png" class="logo-width" alt="">
            </div>
            <h4 class="pt-5">تم تأكيد الدفع بنجاح. نشكركم على ثقتكم</h4>
            <p class="gray-text">عملية الدفع قد تمت بنجاح، وقد تم تأكيد استلام المبلغ المطلوب. نشكركم <br> على ثقتكم ونتطلع إلى خدمتكم دائماً</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'paymentsuccess',
}
</script>